var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.047 3.117a.028.028 0 01-.02.008l-17 .002A.027.027 0 010 3.1v-.308A2.4 2.4 0 012.39.375h12.276a2.406 2.406 0 012.39 2.417v.306a.028.028 0 01-.01.02zm-.058 3.71a.25.25 0 01-.163.079 8 8 0 00-6.996 5.787.25.25 0 01-.24.182h-7.2A2.398 2.398 0 010 10.458V4.652a.027.027 0 01.027-.022h17a.028.028 0 01.028.027v2a.25.25 0 01-.066.17zM6.166 8.624H3.333a.75.75 0 000 1.5h2.833a.75.75 0 100-1.5zm11.446 13a6.107 6.107 0 005.78-4.129 1 1 0 00-1.893-.648 4.105 4.105 0 01-6.927 1.429.25.25 0 01.008-.345l1.731-1.732a.5.5 0 00-.354-.853H11.5a.5.5 0 00-.5.5v4.457a.5.5 0 00.854.353l.958-.958a.252.252 0 01.359 0 6.118 6.118 0 004.441 1.926zm4.428-11.039a.249.249 0 00.082-.056l1.024-1.024a.493.493 0 01.415-.142.5.5 0 01.44.495v4.457a.5.5 0 01-.5.5h-4.458a.5.5 0 01-.353-.853l1.661-1.662a.251.251 0 00.006-.347 4.1 4.1 0 00-6.9 1.452 1.001 1.001 0 01-1.893-.648 6.1 6.1 0 0110.2-2.228.248.248 0 00.276.056z",
    fill: "#8C92A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundIcon);
export default __webpack_public_path__ + "static/media/refund-icon.0f473a713a5aa2550dcd023f12ac502c.svg";
export { ForwardRef as ReactComponent };